var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Box } from "../box";
import { useFormLayoutContext } from "../form-layout";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
export var FormActionsComponentName = "CosmosFormActions";
export var useFormActionsStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            display: "grid",
            gridTemplateColumns: "1fr",
        },
        layoutTwoColumn: (_a = {},
            _a[theme.breakpoints.up("md")] = {
                gridGap: theme.spacing(5),
                gridTemplateColumns: "2fr 3fr",
                "& $actions": {
                    gridColumnStart: 2,
                },
            },
            _a),
        actions: {
            display: "flex",
            alignItems: "center",
        },
        spacing: {
            "& > :not(:last-child)": {
                marginRight: theme.spacing(2),
            },
        },
    });
}, { name: FormActionsComponentName });
export var FormActions = React.forwardRef(function (props, ref) {
    var classes = useFormActionsStyles();
    var layoutContext = useFormLayoutContext().layout;
    var layoutProp = props.layout, _a = props.disableSpacing, disableSpacing = _a === void 0 ? false : _a, children = props.children, className = props.className, 
    // remove to prevent passing through to the root
    propClasses = props.classes, boxProps = __rest(props, ["layout", "disableSpacing", "children", "className", "classes"]);
    var layout = layoutProp || layoutContext;
    return (React.createElement(Box, __assign({ className: clsx(classes.root, layout === "two-column" && classes.layoutTwoColumn, className) }, boxProps),
        React.createElement("div", { className: clsx(classes.actions, !disableSpacing && classes.spacing) }, children)));
});
